import React from 'react';
import { ScrollArea } from '@ohif/ui-next';
import { StudyPreviewCard } from './StudyPreviewCard';

export type StudyPreviewItem = {
  studyInstanceUid: string;
  dateLabel: string;
  description?: string;
  imageSrc?: string;
  isCurrentStudy: boolean;
};

type StudyPreviewBrowserProps = {
  studies: StudyPreviewItem[];
  selectedStudyInstanceUIDs: string[];
  compareStudyInstanceUID: string | null;
  onStudyClick: (studyInstanceUid: string, event?: React.MouseEvent) => void;
  onStudyDoubleClick?: (studyInstanceUid: string) => void;
  scrollable?: boolean;
};

function StudyPreviewBrowser({
  studies,
  selectedStudyInstanceUIDs,
  compareStudyInstanceUID,
  onStudyClick,
  onStudyDoubleClick,
  scrollable = true,
}: StudyPreviewBrowserProps) {
  const previewContent = (
    <div
      className="study-preview-browser flex flex-col gap-2 px-3 pb-3 pt-3"
      data-cy="study-preview-browser"
    >
      {studies.map(study => (
        <StudyPreviewCard
          key={study.studyInstanceUid}
          studyInstanceUid={study.studyInstanceUid}
          dateLabel={study.dateLabel}
          description={study.description}
          imageSrc={study.imageSrc}
          isCurrentStudy={study.isCurrentStudy}
          isSelected={selectedStudyInstanceUIDs.includes(study.studyInstanceUid)}
          isCompareTarget={compareStudyInstanceUID === study.studyInstanceUid}
          onClick={event => onStudyClick(study.studyInstanceUid, event)}
          onDoubleClick={
            onStudyDoubleClick ? () => onStudyDoubleClick(study.studyInstanceUid) : undefined
          }
        />
      ))}
      {!studies.length ? (
        <div className="text-viewer-ink-muted px-1 py-4 text-center text-xs">
          No studies found for this patient.
        </div>
      ) : null}
    </div>
  );

  if (!scrollable) {
    return previewContent;
  }

  return <ScrollArea>{previewContent}</ScrollArea>;
}

export { StudyPreviewBrowser };
